import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/assets";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("You're on Auntie's list.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <footer className="bg-plum text-cream">
      <div className="brand-container py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src={LOGO_URL} alt="Judge Auntie Says" style={{ height: "7rem" }} className="w-auto object-contain" />
          <p className="mt-6 max-w-md text-cream/80 leading-relaxed">
            The court may be adjourned — but Judge <span className="script-auntie text-gold text-xl">Auntie</span>™ still has the mic.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md">
            <input type="email" required placeholder="Join Auntie's mailing list"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 py-3 rounded-full bg-cream/10 border border-cream/20 text-cream placeholder:text-cream/50 focus:outline-none focus:ring-2 focus:ring-gold"
              data-testid="footer-newsletter-email" />
            <button className="btn-outline !border-gold !text-cream hover:!bg-plum-dark" disabled={loading}
              data-testid="footer-newsletter-submit">
              {loading ? "..." : "Subscribe"}
            </button>
          </form>
        </div>
        <div>
          <div className="brand-eyebrow !text-gold mb-4">Explore</div>
          <ul className="space-y-2 text-cream/80">
            <li><Link to="/about" className="hover:text-gold">Meet Judge Auntie™</Link></li>
            <li><Link to="/five-things" className="hover:text-gold">Five Takeaways Series</Link></li>
          </ul>
        </div>
        <div>
          <div className="brand-eyebrow !text-gold mb-4">Connect</div>
          <ul className="space-y-2 text-cream/80">
            <li><Link to="/book" className="hover:text-gold">Book Judge Auntie™</Link></li>
            <li><Link to="/press" className="hover:text-gold">Press Kit</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="brand-container py-6 flex flex-col md:flex-row items-center justify-between text-xs text-cream/60 gap-2">
          <div>© {new Date().getFullYear()} Judge Auntie. All rights reserved.</div>
          <div>™ {new Date().getFullYear()}</div>
        </div>
      </div>
    </footer>
  );
}
